const differentials = [
  {
    icon: 'ri-user-star-line',
    title: 'Atendimento Personalizado',
    description: 'Cada paciente recebe um plano de tratamento individualizado, criado com atenção ao seu histórico, objetivos e estilo de vida.',
  },
  {
    icon: 'ri-medal-line',
    title: 'Profissionais Certificados',
    description: 'Nossa equipe é formada por especialistas com formação contínua nas mais modernas técnicas de saúde e estética.',
  },
  {
    icon: 'ri-pulse-line',
    title: 'Tecnologia de Ponta',
    description: 'Utilizamos equipamentos e insumos de última geração, aprovados pela ANVISA, para resultados seguros e eficazes.',
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Ambiente Acolhedor',
    description: 'Um espaço pensado para que você se sinta em casa — confortável, seguro e longe da correria do dia a dia.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Resultados Naturais',
    description: 'Nossa filosofia é realçar o que há de mais bonito em você, respeitando sua identidade e entregando resultados harmônicos.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Pós-tratamento Completo',
    description: 'Acompanhamos cada etapa da sua jornada, com orientações detalhadas e suporte para potencializar seus resultados.',
  },
];

const Differentials = () => {
  return (
    <section id="diferenciais" className="bg-[#2C2B29] py-20 md:py-28 relative overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20minimalist%20luxury%20texture%20gold%20beige%20pattern%20elegant%20premium%20background%20subtle%20swirl%20soft%20tones%20clinic%20spa%20sophisticated%20design%20element&width=1920&height=900&seq=bg001&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#C4A45A] text-xs tracking-[0.35em] uppercase font-raleway block mb-3">
            Por que nos escolher
          </span>
          <h2 className="font-cormorant text-4xl md:text-5xl text-white font-light mb-4">
            Nossos Diferenciais
          </h2>
          <p className="font-raleway text-white/60 text-sm max-w-xl mx-auto leading-relaxed">
            Na MG+ Saúde &amp; Estética, cada detalhe é pensado para você — do primeiro contato ao resultado final.
          </p>
          <div className="w-12 h-px bg-[#C4A45A] mx-auto mt-6" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {differentials.map((d, i) => (
            <div
              key={i}
              className="border border-white/10 rounded-2xl p-7 hover:border-[#C4A45A]/40 hover:bg-white/5 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C4A45A]/15 text-[#C4A45A] mb-5">
                <i className={`${d.icon} text-xl`}></i>
              </div>
              <h4 className="font-cormorant text-xl text-white font-semibold mb-2">
                <a href="#contato">{d.title}</a>
              </h4>
              <p className="font-raleway text-white/60 text-sm leading-relaxed">{d.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-14">
          <button
            onClick={() => document.querySelector('#contato')?.scrollIntoView({ behavior: 'smooth' })}
            className="border border-[#C4A45A] text-[#C4A45A] font-raleway text-xs tracking-[0.2em] uppercase px-8 py-3.5 rounded-full hover:bg-[#C4A45A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Venha nos Conhecer
          </button>
        </div>
      </div>
    </section>
  );
};

export default Differentials;
